export const TEXT_DELAY = 500;
export const TIME_TO_HIDE = 5000;
